import { useEffect } from "react"
import { useCookies } from "react-cookie"
import queryString from "query-string"

import { useRootQuery } from "graphql/smart-queries/user"

export const WHITELISTED_QUERY_STRING_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "ad_id",
  "adset_id",
  "campaign_id",
  "ad_name",
  "adset_name",
  "campaign_name",
  "placement",
  "site_source_name"
]

/* TODO: check is window.location available in CI */
function useMarketingCookies() {
  const { data } = useRootQuery()
  const [, setCookie] = useCookies(WHITELISTED_QUERY_STRING_PARAMS)

  function setWhitelistedCookies() {
    const parsedQuery = queryString.parse(location.search)

    WHITELISTED_QUERY_STRING_PARAMS.forEach(paramName => {
      if (parsedQuery[paramName]) {
        setCookie(paramName, parsedQuery[paramName])
      }
    })
  }

  useEffect(() => {
    /* The values are used by GTM as a payload for Friendbuy events */
    if (data && data.user) {
      const { id, firstName, lastName, email } = data.user

      /* Friendbuy Smart Pixel variables */
      setCookie("friendbuyCustomerId", id)
      setCookie("friendbuyCustomerEmail", email)
      setCookie("friendbuyCustomerFirstName", firstName)
      setCookie("friendbuyCustomerLastName", lastName)

      /* Friendbuy Conversion Tracker variables */
      setCookie("friendbuyOrderId", `order_user_id_${id}`)
      setCookie("friendbuyOrderAmount", 0)
      setCookie("friendbuyOrderEmail", email)
    }
  }, [data])

  setWhitelistedCookies()
}

export default useMarketingCookies
